export const supportedLanguages = [
    'ar',
    'bg',
    'cs',
    'ca',
    'da',
    'de',
    'el',
    'en',
    'es',
    'fi',
    'fr',
    'he',
    'hi',
    'hu',
    'lt',
    'id',
    'it',
    'ja',
    'ko',
    'ms',
    'nl',
    'no',
    'pl',
    'pt',
    'ro',
    'ru',
    'sk',
    'sv',
    'sl',
    'th',
    'tl',
    'tr',
    'zh',
    'uk',
    'vi',
];
//# sourceMappingURL=supported-languages.js.map